import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ComplianceState } from '../state/compliance.state';

const complianceFeature = createFeatureSelector<ComplianceState>('compliance');

export const selectProfessionTree = createSelector(
    complianceFeature,
    (state) => state.professionSpecialtyConfiguration?.professionTree
);

export const selectProfessionTreeError = createSelector(
    complianceFeature,
    (state) => state.professionSpecialtyConfiguration?.error
);

export const selectProfessionTreeState = createSelector(
    complianceFeature,
    (state) => state.professionSpecialtyConfiguration
);
